import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { VariantCard } from "@academy-context/primary/shared/external-provider-batch-display/variant-card.content";
import type { SubcontractingContract } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { ContractSignatoryFormContainer } from "./contract-signatory-form.container";

const UnsignedContractCardLayout = ({ children }: { children: ReactNode }) => (
  <VariantCard variant="provider" title="Contrat de sous-traitance">
    <div className="space-y-4">
      <p className="flex items-start gap-2 text-sm text-muted-foreground">
        <AlertCircle className="mt-0.5 size-4 shrink-0" />
        Le contrat de sous-traitance doit être signé avant le début de la formation.
      </p>
      {children}
    </div>
  </VariantCard>
);

interface Props {
  // Null until the contract is initialized, PENDING afterwards: the signatory is chosen before signing
  contract: Nullable<SubcontractingContract>;
  legalRepresentative: { firstName: string; lastName: string };
  providerEmail: string;
  onContractInitialized: () => void;
}

export const UnsignedContractCard = ({ contract, legalRepresentative, providerEmail, onContractInitialized }: Props) => (
  <UnsignedContractCardLayout>
    <ContractSignatoryFormContainer
      legalRepresentative={legalRepresentative}
      providerEmail={providerEmail}
      currentSignatory={contract?.signatory ?? null}
      onContractInitialized={onContractInitialized}
    />
  </UnsignedContractCardLayout>
);

export const UnsignableContractCard = () => (
  <UnsignedContractCardLayout>
    <p className="text-sm text-red-600">Le représentant légal n&apos;est pas renseigné : le contrat ne peut pas être signé.</p>
  </UnsignedContractCardLayout>
);
